/**
 * ACORDE — Barra inferior: mantiene al día el contador de favoritos.
 *
 * El carrito ya se actualiza solo (Horizon, <cart-icon>). Los favoritos viven en el teléfono
 * (ver acorde-favoritos.js, misma clave `acorde_favoritos`), así que aquí se lee esa lista y se
 * escucha el evento `acorde:favoritos` que lanza cada corazón al cambiar.
 */
const CLAVE = 'acorde_favoritos';

function contarFavoritos() {
  try {
    const lista = JSON.parse(localStorage.getItem(CLAVE) || '[]');
    return Array.isArray(lista) ? lista.length : 0;
  } catch {
    return 0;
  }
}

class AcordeBarraInferior extends HTMLElement {
  connectedCallback() {
    this.burbuja = this.querySelector('[data-favoritos-conteo]');
    if (!this.burbuja) return;

    this.pintar(contarFavoritos());
    this.alCambiar = (evento) => this.pintar(evento.detail.length);
    document.addEventListener('acorde:favoritos', this.alCambiar);
  }

  disconnectedCallback() {
    document.removeEventListener('acorde:favoritos', this.alCambiar);
  }

  pintar(cantidad) {
    this.burbuja.textContent = cantidad > 99 ? '99+' : String(cantidad);
    this.burbuja.hidden = cantidad === 0;
  }
}

if (!customElements.get('acorde-barra-inferior')) {
  customElements.define('acorde-barra-inferior', AcordeBarraInferior);
}
